import { FC, ReactNode, RefObject } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

type LayoutProps = {
  children: ReactNode
  onSubmit: (data: any) => void
  recaptchaRef: RefObject<ReCAPTCHA>
  formErrors?: {
    email?: {
      message?: string
    }
  }
  serverError?: string
}

const Layout: FC<LayoutProps> = ({
  children,
  onSubmit,
  recaptchaRef,
  formErrors,
  serverError,
}) => {
  return (
    <form onSubmit={onSubmit}>
      <ReCAPTCHA
        theme="dark"
        size="invisible"
        ref={recaptchaRef}
        sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY as string}
        badge="bottomleft"
      />
      {children}
      <p className="text-bidfta-red px-2 text-center w-full">
        {formErrors?.email?.message || serverError}
      </p>
    </form>
  )
}

export default Layout
